import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import {
  ModalRootDiv,
  StyledLeadMoreButton,
  StyledPersonalImage,
  StyledPlanSwitchModal,
} from "./Style/PlanSwitchModal.styles";
import { getDashBoardState, getProjectState } from "@/redux/store";
import { useCallback, useState } from "react";
import { useRouter } from "next/router";
import { projectActions } from "@/redux/stores/projectStore";
import { MODAL_NAME } from "./constants";
import { useTranslation } from "next-i18next";
import { Modal } from "antd";
import axios from "axios";
import Image from "next/image";
import classNames from "classnames";

interface PlanSwitchModalProps {
  // startSubscription: (plan: string, period: boolean) => void;
  // upgradeSubscription: (plan: string, period: boolean) => void;
  // downgradeSubscription: (plan: string, period: boolean) => void;
}

const Slide = ({ children }) => <div className="slide">{children}</div>;

const TeamContents = () => {
  const { t } = useTranslation("common");
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    <Slide key="slide1">
      <StyledPersonalImage
        width={630}
        height={420}
        src="/images/background/CardTeamSwitch.png"
        alt="personal"
      />
    </Slide>,
    <Slide key="slide2">
      <div className="team-step2">
        <div className="headline">
          <div className="header">{t("Team Plan Comparison")}</div>
          <div className="title">{t("If your Team is")}</div>
        </div>
        <StyledPersonalImage
          width={540}
          height={265}
          src="/images/background/PopupTeamSwitch2.png"
          alt="personal"
        />
        <div className="sub-txt">
          *{t("Billing is based on the current number of team seats.")}
        </div>
      </div>
    </Slide>,
  ];

  return (
    <ModalRootDiv>
      {slides[currentSlide]}

      <div className="dots">
        {slides.map((_, index) => (
          <div
            key={index}
            className={classNames(
              "dot",
              index === currentSlide ? "activeDots" : undefined
            )}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </ModalRootDiv>
  );
};

const PersonalContents = () => {
  return (
    <ModalRootDiv>
      <Image
        width={630}
        height={420}
        src="/images/background/CardPersonalSwitch.png"
        alt="personal"
      />
    </ModalRootDiv>
  );
};

export const PlanSwitchModal = (props: PlanSwitchModalProps) => {
  const router = useRouter();
  const { t } = useTranslation("common");
  const { period: userPeriod } = router.query;
  const { accountUserInfo: userInfo, workspaceList } = useAppSelector((store) =>
    getDashBoardState(store)
  );
  const [period, setPeriod] = useState(userPeriod === "monthly" ? true : false);

  const isPersonal = userInfo?.plan?.includes("Personal");

  const imageUrl = userInfo?.plan?.includes("Personal")
    ? "/images/background/CardPersonalSwitch.png"
    : "/images/background/CardTeamSwitch.png";

  const openedModal = useAppSelector(
    (store) => getProjectState(store).openedModal
  );

  const { setOpenedModal } = projectActions;
  const dispatch = useAppDispatch();

  const closeModal = () => {
    if (
      router.query?.openSubscribe === "true" ||
      router.query?.openCheckout === "true"
    ) {
      window.location.replace(window.location.pathname);
    }

    if (userInfo?.interval === "month") {
      setPeriod(true);
    } else {
      setPeriod(false);
    }
    dispatch(setOpenedModal(MODAL_NAME.NONE));
  };

  const switchSubscription = useCallback(async () => {
    try {
      const url = `/api/user/subscriptions/switch`;
      const uriWithoutQueryParam = router?.asPath.split("?")[0];
      const successUrl = `/checkout_redirect?isUpgrade=true&redirect=${uriWithoutQueryParam}`;

      const subscriptionRes = await axios.post(url, {
        plan: userInfo?.plan?.includes("Team") ? "team" : "personal", //현재 플랜
        periodKey: userInfo?.interval === "month" ? "monthly" : "yearly", //현재 주기
        seats:
          workspaceList?.length > 0 ? 3 - workspaceList[0]?.availableSeats : 1, //현재 팀멤버수
        successUrl,
      });

      // console.log("!@#!@#!@# subscriptionRes", subscriptionRes.data);

      if (subscriptionRes.data.success) {
        router?.replace(subscriptionRes.data.data);
      } else {
        Modal.error({ content: subscriptionRes.data.data.msg });
        console.log("error subscriptionRes: ", subscriptionRes.data);
      }
    } catch (e) {
      console.log("switchSubscription error ", e);
    }
  }, [router, userInfo?.interval, userInfo?.plan, workspaceList]);

  return (
    <StyledPlanSwitchModal
      title={null}
      width={650}
      centered
      open={openedModal === MODAL_NAME.PLAN_SWITCH}
      footer={
        <div className="more-section">
          <div className="message">
            {t("Switch To Unlimited-Same Price, More Value!")}
          </div>
          <StyledLeadMoreButton type="primary" onClick={switchSubscription}>
            {t("Switch To Unlimited Now")}
          </StyledLeadMoreButton>
        </div>
      }
      onCancel={closeModal}
      zIndex={1000}
    >
      {isPersonal && <PersonalContents />}
      {!isPersonal && <TeamContents />}
    </StyledPlanSwitchModal>
  );
};
